export const identityServicePaths = {
  login: '/login',
  signup: '/signup',
  consentPath: '/oauth2/consent',
  employeeLoginPath: '/login/employee',
}
